<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="overview-wrap m-b-15">
          <h2 class="title-1">
            {{ text('watch_folder_header') }} ({{ watchfolders.length}})
          </h2>
          <v-btn color="success" @click="newWF()">
            <i class="zmdi zmdi-plus p-r-10"></i>{{ text('add_wf_btn') }}
          </v-btn>
        </div>
        <div class="row" v-if="!loading && !watchfolders.length">
          <div class="col-md-12 text-center p-4">
            {{ text('no_wf') }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-4" v-for="wf of watchfolders" :key="wf.id">
            <v-hover>
              <v-card
                class="mx-auto m-3 p-2 pointer"
                slot-scope="{ hover }"
                @click="goToDetailPage(wf)"
                :class="`elevation-${hover ? 12 : 2}`">
                <div class="row">
                  <div class="col-md-6">
                    <v-list two-line>
                      <v-list-tile>
                        <v-list-tile-content>
                          <v-list-tile-title class="headline">
                            {{ wf.name }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title>
                            {{ formatTime(wf.createTime) }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </div>
                  <div class="col-md-6 text-right headline v-align p-r-40">
                    <i class="fa fa-circle-notch fa-spin job-status--finished"
                       v-if="wf.state === 'active'">
                    </i>
                    <i class="fa fa-check-circle job-status--finished"
                       v-if="wf.state === 'finished'">
                    </i>
                    <i class="fa fa-exclamation-circle job-status--failed"
                       v-if="wf.state === 'error'">
                    </i>
                    {{ wf.state }}
                  </div>
                </div>

                <v-list two-line>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="indigo">zmdi-folder-outline</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ wf.url }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="indigo">zmdi-cloud-download</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                      <v-list-tile-title>{{ wf.outputs.length }} outputs</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-hover>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { processWatchFolder } from '@/store/converters';

export default {
  created() {
    this.$store.commit('setPageLoader');
    this.loadData();
  },
  data() {
    return {
      watchfolders: [],
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    formatTime(time) {
      return moment(time).format('MMM D, YYYY HH:mm');
    },
    goToDetailPage(wf) {
      this.$router.push({
        name: 'WatchFolderDetailPage',
        params: {
          id: wf.id,
        },
      });
    },
    loadData() {
      const args = {
        limit: 100,
        offset: 0,
      };
      this.$store.dispatch('watchFolders/getWatchFolders', args)
        .then((watchfolders) => {
          this.watchfolders = watchfolders.map((wf) => {
            const newWF = processWatchFolder(wf);
            if (newWF.state === '') {
              newWF.state = 'active';
            }
            if (newWF.state === 'ok') {
              newWF.state = newWF.closed ? 'finished' : 'active';
            }
            return newWF;
          });
        })
        .catch((errorMsg) => {
          this.$store.commit('resolvePageLoader');
          this.$toasted.error(errorMsg, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 10000,
          });
        })
        .finally(() => this.$store.commit('resolvePageLoader'));
    },
    newWF() {
      this.$router.push({ name: 'WatchFolderNewPage' });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
